export default "__VITE_ASSET__CfKBiPs3__"